import React from 'react';

const DefaultCard = (props) => {

    return (
        <article className="card post">

            <a href={props.url}>

                <div className="image">

                    <img src={props.image} />

                </div>

            </a>

            <div className="content">

                <a href={props.url}>

                    <h6 dangerouslySetInnerHTML={{ __html: props.title }}></h6>

                    <div className="excerpt" dangerouslySetInnerHTML={{ __html: props.excerpt }}></div>

                </a>

            </div>

        </article>
    );

}

export default DefaultCard;

/*
<article class="card  post">

    <a href="http://church.test/2018/01/07/fcc-team-bash/">

        <div class="image">

            <img src="http://church.test/wp-content/uploads/2018/10/FCC-Team-Bash-Final-1-545x310.jpg">

        </div>

        </a><div class="content"><a href="http://church.test/2018/01/07/fcc-team-bash/">

            <h6>FCC Team Bash</h6>


                <div class="excerpt">FCC is celebrating service by honoring all our folks who “Serve on the team.” All team members are encouraged to join us for a...</div>

                </a><div class="author"><a href="http://church.test/2018/01/07/fcc-team-bash/">

    </a><div class="author-profile-picture"><a href="http://church.test/2018/01/07/fcc-team-bash/">

        </a><div class="author-profile-picture"><a href="http://church.test/2018/01/07/fcc-team-bash/">

            </a><a href="http://church.test/people/tommy-staggs/"><img src="http://church.test/wp-content/themes/church-emphasis/assets/dist/img/default-avatar.jpg"></a>

        </div>

    </div>

</div>



        </div>





</article>*/
